const COUNTRY_SELECTOR_POP_UP_CLASSES_PREFIX = "CountrySelectorPopup";

export const COUNTRY_SELECTOR_POP_UP_CLASSES = {
  popup: `${COUNTRY_SELECTOR_POP_UP_CLASSES_PREFIX}-popup`,
  closeButton: `${COUNTRY_SELECTOR_POP_UP_CLASSES_PREFIX}-close-button`,
  title: `${COUNTRY_SELECTOR_POP_UP_CLASSES_PREFIX}-title`,
  description: `${COUNTRY_SELECTOR_POP_UP_CLASSES_PREFIX}-description`,
  countryItemWrap: `${COUNTRY_SELECTOR_POP_UP_CLASSES_PREFIX}-country-item-wrap`,
  countryItem: `${COUNTRY_SELECTOR_POP_UP_CLASSES_PREFIX}-country-item`,
  icon: `${COUNTRY_SELECTOR_POP_UP_CLASSES_PREFIX}-icon`,
};
